import React, { Fragment, Children } from "react";
import PropTypes from "prop-types";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';

const Body = styled.div`
    height: calc(100% - 104px);;
`;

const styles = theme => ({
    tabLabel: {
        textTransform: 'none',
        fontSize: '18px'
    },
    appHeader: {
        boxShadow: 'none'
    }
});

class ScrollableViewWithTabs extends React.Component{

	constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeIndex = this.handleChangeIndex.bind(this);
    }

    handleChange(event, tabIndex){
        this.setState({ tabIndex });
    };

    handleChangeIndex(tabIndex){
        this.setState({ tabIndex });
    };

	render(){
		const{ tabConfig, theme, children, classes } = this.props;
		const __tabs = Children.map(children, (child, childIndex) => {
            let _props = {
                index: childIndex,
                key:`tab_scroll__${childIndex}`,
                dir: theme.direction
            };
            return React.cloneElement(child, _props);
		})
		return <Fragment>
		 	<AppBar className={classes.appHeader} position="static" color="inherit">
                <Tabs
                    value={this.state.tabIndex}
                    onChange={this.handleChange}
                    indicatorColor="secondary"
                    textColor="secondary"
                    fullWidth
                >
                	{
                		tabConfig.map((el,index)=> {
                			return <Tab className={`${classes.tabLabel} montserratSemiBold`} key={index} label={el.label} />
                		})
                	}
                </Tabs>
            </AppBar>
            <Body>
                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={this.state.tabIndex}
                    onChangeIndex={this.handleChangeIndex}
                    style={{height: '100%'}}
                >
                   {__tabs}
                </SwipeableViews>
            </Body>
        </Fragment>
	}
}

ScrollableViewWithTabs.defaultProps = {
    tabConfig:[],
    classes: {}
};

ScrollableViewWithTabs.propTypes = {
    classes:PropTypes.object,
    theme:PropTypes.object,
    tabConfig:PropTypes.array,
}

export default withStyles(styles, { withTheme: true })(ScrollableViewWithTabs);


// WEBPACK FOOTER //
// ./src/components/ScrollableViewWithTabs.js